const initialState = {
  data: [],
};

const providersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROVIDERS':
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default providersReducer;
